// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 1,
    title: "✣ WHO'S WHO",
    desc: 'Music guessing game app built with React utilizing the Spotify API.',
    image: require('../assets/who.png'),
    link: 'https://github.com/sejobasic/Whos-Who'
  },
  {
    id: 2,
    title: "✣ ABLETON WRAPPED",
    desc: 'Personalized Ableton wrap stats app built with React.',
    image: require('../assets/ableton.png'),
    link: 'https://abletonwrapped.com'
  },
  {
    id: 3,
    title: '✣ THE FRIED HANGOVER',
    image: require('../assets/hangover.png'),
    desc: 'Food truck restaurant app built with React.',
    link: 'https://the-fried-hangover.netlify.app/'
  },
  {
    id: 4,
    title: '✣ LAYR SEQUENCER',
    image: require('../assets/layr.png'),
    desc: 'Music sequencer app built with React and Ruby on Rails.',
    link: 'https://github.com/sejobasic/Layr-Sequencer'
  },
  {
    id: 5,
    title: '✣ GAMEFOLD',
    image: require('../assets/gamefold.png'),
    desc: 'Sports game app built with React.',
    link: 'https://gamefold.net'
  },
  {
    id: 6,
    title: '✣ DASHBOARD',
    desc: 'Personal dashboard chrome extension utilizing the Unsplash and Weather API built with React.',
    image: require('../assets/dashboard.png'),
    link: 'https://github.com/sejobasic/Personal-Dashboard-Project'
  },
  {
    id: 7,
    title: '✣ PORTAL',
    desc: 'Full-stack company management app built with React, Java, Spring Boot and PostgreSQL.',
    image: require('../assets/portal.png'),
    link: 'https://github.com/sejobasic/Company-Management'
  },
  {
    id: 8,
    title: '✣ IPOD NANO',
    desc: '3D iPod Nano model built with Three.js and WEBGL.',
    image: require('../assets/lore-nano.png'),
    link: 'https://lore-nano.netlify.app/'
  }
]
